import http from 'hub-http/clients/apiClient';

const EVENTBRITE_OAUTH_URL = '/eventbrite/v1/oauth';

export const postAuthData = (authData: string) =>
  http.post(EVENTBRITE_OAUTH_URL, {
    data: {
      responseKey: authData,
    },
  });
